import { debounce } from '@griply/utils';
import { useEffect, useMemo, useState } from 'react';

export const useDebounce = <Callback extends (...args: any[]) => any>(
  callback: Callback,
  timeout?: number,
) => useMemo(() => debounce(callback, timeout), [callback, timeout]);

export const useDebounceValue = <Value>(value: Value, timeout = 200) => {
  const [debouncedValue, setDebouncedValue] = useState<Value>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, timeout);

    return () => clearTimeout(timer);
  }, [value, timeout]);

  return debouncedValue;
};
